module.exports = __webpack_public_path__ + "img/measurement_info_left_waist_back.3680113d.jpg";